/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import { ValidationErrorFieldsFragmentDoc } from '../../../context/Customer/GraphQL/ForgotPassword.generated';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderHistoryQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type OrderHistoryQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly wantedTime: string;
          readonly description: string;
          readonly total: number | null;
          readonly lineItems: ReadonlyArray<{
            readonly __typename?: 'LineItem';
            readonly id: string;
            readonly customName: string | null;
            readonly isCustom: boolean;
            readonly product: {
              readonly __typename?: 'Product';
              readonly id: string;
              readonly name: string;
              readonly isCustom: boolean;
              readonly categoryName: string;
            };
          }>;
          readonly asset: {
            readonly __typename?: 'Asset';
            readonly url: string;
          };
          readonly restaurant: {
            readonly __typename?: 'Restaurant';
            readonly id: string;
            readonly name: string;
            readonly isOutpost: boolean;
          };
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly name: string | null;
            };
          } | null;
        }>;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const orderHistoryQueryMock: ExecutionResult<OrderHistoryQuery> = {
  data: {
    orders: {
      __typename: 'OrdersResponseSuccess',
      orders: [
        {
          id: '509e6ea9-fee4-42a9-9625-87ce71904308',
          orderType: 'DELIVERY',
          wantedTime: 'Hello World',
          description: 'Hello World',
          total: 65,
          lineItems: [
            {
              id: '7a7163ba-7eda-496e-8a18-5e3da00a9a47',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '34319d08-060b-459a-a250-f9c4016b1bd6',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
            {
              id: '4cb273b7-f9f1-48d0-b0f1-b1f2c49f5fd7',
              customName: 'Hello World',
              isCustom: true,
              product: {
                id: '94ccdcab-38b7-4485-afbe-88532ede7a1d',
                name: 'Hello World',
                isCustom: true,
                categoryName: 'Hello World',
              },
            },
            {
              id: 'a933e0e0-95a7-4b48-b0bb-560d0180d39c',
              customName: 'Hello World',
              isCustom: true,
              product: {
                id: '0c0520a3-52a4-4a65-81b5-bc5d089f52e9',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
          ],
          asset: { url: 'Hello World' },
          restaurant: {
            id: '1d91bfdf-babd-438f-9f8e-b150587b384c',
            name: 'Hello World',
            isOutpost: false,
          },
          deliveryOrderDetail: {
            id: '8299be51-1f9b-41e3-9b6d-74afbe52f8a3',
            address: {
              id: 'a6f32f0e-daef-4122-810a-f291521b27f2',
              name: 'Hello World',
            },
          },
        },
        {
          id: 'badd9c8f-96f0-410c-a153-96429788b394',
          orderType: 'DELIVERY',
          wantedTime: 'Hello World',
          description: 'Hello World',
          total: -81,
          lineItems: [
            {
              id: '8d500493-4e08-40ad-bfd6-2514dd94f36b',
              customName: 'Hello World',
              isCustom: false,
              product: {
                id: '1c23d4c4-b96c-4aa8-a22a-517d3cbc3f05',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
          ],
          asset: { url: 'Hello World' },
          restaurant: {
            id: '67a358d4-51b9-4313-a63d-b9eb2f517f53',
            name: 'Hello World',
            isOutpost: false,
          },
          deliveryOrderDetail: {
            id: 'a27f5acf-bda0-43bf-af7e-27a59a381e64',
            address: {
              id: '855fe3c2-470d-45f3-8aff-27422c629331',
              name: 'Hello World',
            },
          },
        },
        {
          id: '69f0cff6-a934-47d8-8d8e-ee30f22b944d',
          orderType: 'DELIVERY',
          wantedTime: 'Hello World',
          description: 'Hello World',
          total: -64,
          lineItems: [
            {
              id: '3ab94c40-1307-4664-855f-9f516095e6ed',
              customName: 'Hello World',
              isCustom: true,
              product: {
                id: 'dc961aae-ec36-4e40-945d-8c254bfa7591',
                name: 'Hello World',
                isCustom: false,
                categoryName: 'Hello World',
              },
            },
          ],
          asset: { url: 'Hello World' },
          restaurant: {
            id: '5291a955-11cb-4ad1-a171-218cef4b3e48',
            name: 'Hello World',
            isOutpost: true,
          },
          deliveryOrderDetail: {
            id: 'b0e31ab2-6ed5-4bc4-88c1-e299d2034853',
            address: {
              id: '385b5d1d-6c3a-43f0-a8c5-aed63622b166',
              name: 'Hello World',
            },
          },
        },
      ],
    },
  },
};

export const OrderHistoryDocument = gql`
  query orderHistory($input: OrdersInput!) {
    orders(input: $input) {
      __typename
      ... on OrdersResponseSuccess {
        orders {
          id
          orderType
          wantedTime
          description
          total
          lineItems {
            id
            customName
            isCustom
            product {
              id
              name
              isCustom
              categoryName
            }
          }
          asset {
            url
          }
          restaurant {
            id
            name
            isOutpost
          }
          deliveryOrderDetail {
            id
            address {
              id
              name
            }
          }
        }
      }
      ...ValidationErrorFields
    }
  }
  ${ValidationErrorFieldsFragmentDoc}
`;

export function useOrderHistoryQuery(
  options: Omit<Urql.UseQueryArgs<OrderHistoryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<OrderHistoryQuery, OrderHistoryQueryVariables>({
    query: OrderHistoryDocument,
    ...options,
  });
}
